export const formatCompactUsd = (value: number): string => {
  if (value >= 1_000_000) {
    return `$${(value / 1_000_000).toFixed(1)}M`;
  }
  if (value >= 1_000) {
    return `$${(value / 1_000).toFixed(1)}K`;
  }
  return `$${value.toFixed(0)}`;
};

export const formatPercentApy = (apy: number): string => {
  return `${(apy * 100).toFixed(1)}%`;
};
